import { Box, colors, Typography } from '@mui/material';
import CustomPieChart from 'components/shared/CustomPieChart/CustomPieChart';
import zeplinColor from 'theme/Color';

const genderColors = ['#4A90E2', '#F05A7E', '#FDCB6E', '#00B894', '#6C5CE7'];
const familyStatusColors = ['#6C5CE7', '#00B894', '#FDCB6E', '#4A90E2', '#F05A7E'];
const BasicPreview = ({
  setTabValue,
  value,
}: {
  setTabValue: React.Dispatch<React.SetStateAction<number>>;
  value: any;
}) => {
  const genderItems = value?.gender?.map((item: any, index: number) => ({
    ...item,
    value: item?.size,
    color: genderColors[index],
  }));

  const familyStatusItems = value?.familyStatus?.map((item: any, index: number) => ({
    ...item,
    value: item?.size,
    color: familyStatusColors[index],
  }));

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '12px',
        flexDirection: 'column',
        borderRadius: '14px',
        border: `1px solid ${zeplinColor.Neutral5}`,
        padding: { xs: '12px 16px', xl: '16px' },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant='responsiveHeading3'>Basic Stats</Typography>
        <Typography
          variant='responsiveButtonSmall'
          color={zeplinColor.Brand1}
          sx={{ cursor: 'pointer' }}
          onClick={() => setTabValue(1)}
        >
          View All
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: '12px',

          flex: 1,
        }}
      >
        <CustomPieChart title='Gender' items={genderItems} />
        <CustomPieChart title='Family Status' items={familyStatusItems} />
      </Box>
    </Box>
  );
};

export default BasicPreview;
